import React, { useEffect, useState } from 'react';
import type { InputValue, TagInputProps, TagInputValue } from 'tdesign-react';
import { TagInput } from 'tdesign-react';

export const TagInputComponent: React.FC<
{
  config: any;
  getFieldDecorator: any;
  value: any;
  tokenSeparators?: string[];
  onChange: (value: string[]) => {};
} & TagInputProps
> = (props) => {
  const { tokenSeparators = [','] } = props;
  const [compValue, setCompValue] = useState<string[]>(props.value || []);
  const [inputValue, setInputValue] = useState<string>('');

  const reg = new RegExp(tokenSeparators.join('|'), 'g');

  const resetInputValue = (context: string) => {
    if (!context) {
      return;
    }
    const value = context.split(reg).filter(item => !!item);
    props.onChange([...compValue, ...(value as string[])]);
    setInputValue('');
  };

  const onInputChange = (inputStr: InputValue) => {
    if (typeof inputStr !== 'string') {
      return;
    }
    if (reg.test(inputStr)) {
      resetInputValue(inputStr);
      return;
    }
    setInputValue(inputStr);
  };

  const onEnter = (value: TagInputValue) => {
    setCompValue([...(value as string[])]);
  };

  const onChange = (value: TagInputValue) => {
    props.onChange([...(value as string[])]);
  };

  const onRemove = (context: { value: TagInputValue; index: number }) => {
    const temp = [...compValue];
    temp.splice(context.index, 1);
    setCompValue([...temp]);
    setInputValue('');
  };

  const onClear = () => {
    setInputValue('');
  };

  useEffect(() => {
    setCompValue(props.value || []);
  }, [props.value]);

  return (
    <TagInput
      {...props}
      value={compValue}
      inputValue={inputValue}
      onChange={onChange}
      onEnter={onEnter}
      onRemove={onRemove}
      onClear={onClear}
      onBlur={(_input, context) => {
        resetInputValue(context.inputValue as string);
      }}
      onInputChange={onInputChange}
    ></TagInput>
  );
};
